import React from 'react';
import { connect } from 'react-redux';
import { activeBreadCrumbTotalResult } from '@Containers/Breadcrumbs/BreadcrumbsSelectors';
import { resultsPerPage } from '@Pages/Results/selectors';
import { pageNumber } from '@Selectors/StateParamsSelectors';
import { selectPage } from '../ResultsPaginationActions';

import {
  getVisibleRange as getVisibleRangeHelper,
  getTotalPages as getTotalPagesHelper,
  shouldDisplayGoToPage as shouldDisplayGoToPageHelper,
} from '../ResultsPaginationHelper';
// eslint-disable-next-line
import Pagination from './Pagination';

export function PaginationContainer(props) {
  const totalPages = getTotalPagesHelper(props);
  const visibleRange = getVisibleRangeHelper(props);
  const shouldDisplayGoToPage = shouldDisplayGoToPageHelper(props);

  return <Pagination {...props} totalPages={totalPages} visibleRange={visibleRange} shouldDisplayGoToPage={shouldDisplayGoToPage} />;
}

function mapStateToProps(state) {
  return {
    totalItems: activeBreadCrumbTotalResult(state),
    currentPage: parseInt(pageNumber(state), 10),
    itemsPerPage: resultsPerPage(state),
    resultsPerPage: resultsPerPage(state),
  };
}

const mapDispatchToProps = {
  onSelect: selectPage,
};

export default connect(mapStateToProps, mapDispatchToProps)(PaginationContainer);
